/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";
import {
  QueryTrendSource,
  QueryTrendSource$Outbound,
  QueryTrendSource$outboundSchema,
} from "./querytrendsource.js";

/**
 * Sampling interval in seconds. Snapped up to the nearest allowed value if the requested interval would exceed max_points.
 */
export const SamplingInterval = {
  PerSecond: 1,
  PerFifteenSeconds: 15,
  PerMinute: 60,
  PerFifteenMinutes: 900,
  PerHour: 3600,
} as const;
/**
 * Sampling interval in seconds. Snapped up to the nearest allowed value if the requested interval would exceed max_points.
 */
export type SamplingInterval = ClosedEnum<typeof SamplingInterval>;

export type QueryTrendsRequestBody = {
  /**
   * End of the query range.
   */
  end?: Date | undefined;
  /**
   * Facility timezone for the query.
   */
  facilityTimezone: string;
  /**
   * Whether to include normalized values.
   */
  includeNormalized?: boolean | undefined;
  /**
   * Sampling interval in seconds. Snapped up to the nearest allowed value if the requested interval would exceed max_points.
   */
  samplingInterval: SamplingInterval;
  /**
   * Maximum number of points to return; interval may be increased to stay at or under this.
   */
  maxPoints?: number | undefined;
  /**
   * Sources to query with type and value kind.
   */
  sources: Array<QueryTrendSource>;
  /**
   * Start of the query range.
   */
  start: Date;
};

/** @internal */
export const SamplingInterval$outboundSchema: z.ZodNativeEnum<
  typeof SamplingInterval
> = z.nativeEnum(SamplingInterval);

/** @internal */
export type QueryTrendsRequestBody$Outbound = {
  end?: string | undefined;
  facility_timezone: string;
  include_normalized: boolean;
  interval: number;
  max_points: number;
  sources: Array<QueryTrendSource$Outbound>;
  start: string;
};

/** @internal */
export const QueryTrendsRequestBody$outboundSchema: z.ZodType<
  QueryTrendsRequestBody$Outbound,
  z.ZodTypeDef,
  QueryTrendsRequestBody
> = z.object({
  end: z.date().transform(v => v.toISOString()).optional(),
  facilityTimezone: z.string(),
  includeNormalized: z.boolean().default(false),
  samplingInterval: SamplingInterval$outboundSchema,
  maxPoints: z.number().int().default(10000),
  sources: z.array(QueryTrendSource$outboundSchema),
  start: z.date().transform(v => v.toISOString()),
}).transform((v) => {
  return remap$(v, {
    facilityTimezone: "facility_timezone",
    includeNormalized: "include_normalized",
    samplingInterval: "interval",
    maxPoints: "max_points",
  });
});

export function queryTrendsRequestBodyToJSON(
  queryTrendsRequestBody: QueryTrendsRequestBody,
): string {
  return JSON.stringify(
    QueryTrendsRequestBody$outboundSchema.parse(queryTrendsRequestBody),
  );
}
